import tokens from "../../../tokens.js";
import { PopOver } from "../PopOver.jsx";
import styles from "../popOver.css.js";

/**
 * UserTour
 * Decorates the Joyride Library Component (https://docs.react-joyride.com/)
 * Control via state can be used by with callback, run and stepIndex.
 *
 * @param {Object} config - Configuration object for the UserTour.
 * @param {Array<Object>} config.steps - An array of step objects, each representing a step in the tour.
 *    The last step will automatically hide the backButton and apply custom styles to the nextButton for differentiation.
 * @param {boolean} [config.disableOverlay=false] - Disables the semi-transparent overlay displayed during the tour.
 * @param {Function} config.callback - A function to execute at certain callback events during the tour (e.g., when a step ends or the tour ends).
 * @param {boolean} config.run - Determines whether the tour should start running immediately upon rendering.
 * @param {number} config.stepIndex - Current step index.
 * @returns {JSX.Element} A component rendering the user tour with predefined steps and customizable styling options.
 */
export const UserTour = ({
  steps,
  disableOverlay = false,
  callback,
  run,
  stepIndex,
}) => {
  // Do not show the backButton on the last step of the tour
  // And style the nextButton (which finishes the tour in this case) differently
  const tourSteps = steps.map((step, index) =>
    index === steps.length - 1
      ? {
          ...step,
          hideBackButton: true,
          styles: { buttonNext: styles.buttonOnly },
        }
      : step,
  );

  return (
    <PopOver
      steps={tourSteps}
      disableOverlay={disableOverlay}
      disableOverlayClose={true}
      hideCloseButton={true}
      customStyles={{
        options: {
          primaryColor: tokens.color.core.primary,
          textColor: tokens.color.full.gray600,
        },
      }}
      callback={callback}
      run={run}
      stepIndex={stepIndex}
    />
  );
};
